import React from 'react';

import { Error404 } from '../../../shared/components/error-404';
import { Layout } from '../../components/layout';

export const ErrorPage = () => (
    <Layout>
        <Error404 />
    </Layout>
);
